var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_862_67850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_862_67850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.005 0.5H0.00500488V36.5H36.005V0.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_862_67850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_862_67850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.005 0.5H0.00500488V36.5H36.005V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_862_67850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.839 5.66797C31.8112 5.66837 32.7434 6.05473 33.4308 6.74216C34.1182 7.42958 34.5046 8.36181 34.505 9.33397V11.167H1.505V9.33397C1.505 8.36169 1.89124 7.42922 2.57875 6.74172C3.26626 6.05421 4.19872 5.66797 5.171 5.66797H30.839ZM34.505 27.6685C34.5038 28.6404 34.1172 29.5722 33.4299 30.2594C32.7427 30.9467 31.8109 31.3333 30.839 31.3345H5.171C4.19884 31.3341 3.26661 30.9477 2.57919 30.2603C1.89177 29.5729 1.5054 28.6406 1.505 27.6685V16.6675H34.505V27.6685ZM7.922 24.001C7.67893 24.001 7.44582 24.0975 7.27394 24.2694C7.10206 24.4413 7.0055 24.6744 7.0055 24.9175C7.0055 25.1605 7.10206 25.3937 7.27394 25.5655C7.44582 25.7374 7.67893 25.834 7.922 25.834H11.588C11.8311 25.834 12.0642 25.7374 12.2361 25.5655C12.4079 25.3937 12.5045 25.1605 12.5045 24.9175C12.5045 24.6744 12.4079 24.4413 12.2361 24.2694C12.0642 24.0975 11.8311 24.001 11.588 24.001H7.922ZM15.2555 25.834H22.589C22.8321 25.834 23.0652 25.7374 23.2371 25.5655C23.4089 25.3937 23.5055 25.1605 23.5055 24.9175C23.5055 24.6744 23.4089 24.4413 23.2371 24.2694C23.0652 24.0975 22.8321 24.001 22.589 24.001H15.2555C15.0124 24.001 14.7793 24.0975 14.6074 24.2694C14.4356 24.4413 14.339 24.6744 14.339 24.9175C14.339 25.1605 14.4356 25.3937 14.6074 25.5655C14.7793 25.7374 15.0124 25.834 15.2555 25.834Z",
    fill: "url(#paint0_linear_862_67850)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_67850",
    x1: 30.743,
    y1: 29.0502,
    x2: 14.6604,
    y2: 8.43636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD04E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_67850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.00500488 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTransfer);
export default __webpack_public_path__ + "static/media/CardTransfer.0e05555b953a4e940c620659335cb1a3.svg";
export { ForwardRef as ReactComponent };